export const BACKEND_API_BASE_URL = "https://applymend.atservicecrm.com/api/";;
export const CDN_URL = "https://applymend.atservicecrm.com/";;
